import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import wixLogo from '../assets/wix.png'; // Asegúrate de tener el logo de Wix en esta ruta
import agFacturaLogo from '../assets/ag.png';
import bidireccional from '../assets/bidireccional.png';
import Login from './Login';
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes, FaSignOutAlt, FaDesktop } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
/* global BigInt */

const API_URL = process.env.REACT_APP_API_URL; // Asegúrate de que esta variable esté definida en tu .env

export default function AdminConfig() {
  const navigate = useNavigate();
  const [wixSites, setWixSites] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [clients, setClients] = useState([]);
  const [editingClient, setEditingClient] = useState(null);
  const [form, setForm] = useState({ subdomain: '', client_id: '', secret_key: '' });
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    const logged = localStorage.getItem('loggedIn') === 'true';
    setIsLoggedIn(logged);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchClients();
      fetchWixSites(); // cargar sitios Wix también
    }
  }, [isLoggedIn]);

  const fetchWixSites = async () => {
    try {
      const res = await axios.get(API_URL + '/wix-api/wix-sites', {
        headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
      });
      setWixSites(res.data);
    } catch (error) {
      console.error('Error cargando sitios de Wix', error);
    }
  };

  const fetchClients = async () => {
    try {
      const res = await axios.get(API_URL + '/clients', {
        headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
      });
      setClients(res.data);
    } catch (error) {
      //console.error('Error cargando clientes', res);
      console.error('Error cargando clientes', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error cargando clientes',
        footer: error?.response?.data?.message || error.message || ''
      });
    }
  };

  const startEdit = (client) => {
    setEditingClient(client);
    setForm({
      subdomain: client.subdomain,
      client_id: client.client_id,
      secret_key: client.secret_key,
      wix_site_id: client.wix_site_id || '',
      wix_site_name: client.wix_site_name || '',
      estado: client.estado || 'A',
      fecha_control: client.fecha_control || '',
      bodega_inventario: client.bodega_inventario || '',
      wix_app_instance_id: client.wix_app_instance_id || ''
    });
    setIsNew(false);
  };

  const startNew = () => {
    setEditingClient(null);
    setForm({ subdomain: '', client_id: '', secret_key: '', wix_site_id: '', wix_site_name: '', estado: 'A', bodega_inventario: '', wix_app_instance_id: '' });
    setIsNew(true);
  };

  const cancelEdit = () => {
    setEditingClient(null);
    setIsNew(false);
    setForm({ subdomain: '', client_id: '', secret_key: '', wix_site_id: '', wix_site_name: '', estado: 'A', bodega_inventario: '', wix_app_instance_id: '' });
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const saveClient = async () => {
    try {
      if (isNew) {
        await axios.post(API_URL + '/clients', form, {
          headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
        });
      } else if (editingClient) {
        await axios.put(`${API_URL}/clients/${editingClient.id}`, form, {
          headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
        });
      }
      fetchClients();
      cancelEdit();
    } catch (error) {
      console.error('Error guardando cliente', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error guardando cliente',
        footer: error?.response?.data?.message || error.message || ''
      });
    }
  };

  const deleteClient = async (clientId) => {
    const result = await Swal.fire({
      title: '¿Eliminar cliente?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_URL}/clients/${clientId}`, {
          headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
        });
        fetchClients();
      } catch (error) {
        console.error('Error eliminando cliente', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error eliminando cliente',
          footer: error?.response?.data?.message || error.message || ''
        });
      }
    }
  };

  if (!isLoggedIn) {
    return <Login onLogin={setIsLoggedIn} />;
  }

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">AG Factura Wix Stores Connector</h1>
        <button
          onClick={() => {
            navigate('/');
          }}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 flex items-center gap-2"
        >
          <FaDesktop />
          Monitoreo
        </button>
        <button
          onClick={() => {
            localStorage.removeItem('loggedIn');
            setIsLoggedIn(false);
          }}
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 flex items-center gap-2"
        >
          <FaSignOutAlt />
          Cerrar sesión
        </button>
      </div>

      <div className="flex gap-4 items-center mb-6">
        <img src={wixLogo} alt="Wix Logo" className="h-12 rounded" />
        <img src={bidireccional} alt="AG Factura Logo" className="h-12" />
        <img src={agFacturaLogo} alt="AG Factura Logo" className="h-12" />
      </div>

      {!editingClient && !isNew && (
        <>
          <button
            className="mb-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
            onClick={startNew}
          >
            <FaPlus />Nuevo Cliente
          </button>

          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border px-4 py-2">Subdominio</th>
                <th className="border px-4 py-2">Client ID</th>
                <th className="border px-4 py-2">Secret Key</th>
                <th className="border px-4 py-2">Wix Site</th>
                <th className="border px-4 py-2">UUID</th>
                <th className="border px-4 py-2">Bodega</th>
                <th className="border px-4 py-2">Estado</th>
                <th className="border px-4 py-2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client) => (
                <tr key={client.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{client.subdomain}</td>
                  <td className="border px-4 py-2">{client.client_id}</td>
                  <td className="border px-4 py-2">**********</td>
                  <td className="border px-4 py-2">{client.wix_site_name}</td>
                  <td className="border px-4 py-2">{uuidToAlphaOnly(client.wix_site_id)}</td>
                  <td className="border px-4 py-2">{client.bodega_inventario}</td>
                  <td className="border px-4 py-2">
                    {client.estado === 'A' ? (
                      <span className="px-2 py-1 rounded bg-green-100 text-green-700 font-semibold">Activo</span>
                    ) : (
                      <span className="px-2 py-1 rounded bg-red-100 text-red-700 font-semibold">Inactivo</span>
                    )}
                  </td>
                  
                  <td className="border px-4 py-2 flex gap-2">
                    <button
                      className="px-2 py-1 bg-yellow-400 text-black rounded hover:bg-yellow-500 flex items-center gap-1"
                      onClick={() => startEdit(client)}
                    >
                      <FaEdit /> Editar
                    </button>
                    <button
                      className="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700 flex items-center gap-1"
                      onClick={() => deleteClient(client.id)}
                    >
                      <FaTrash />
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
              {clients.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No hay clientes configurados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}

      {(editingClient || isNew) && (
        <div className="border p-4 rounded max-w-md">
          <h2 className="text-xl mb-4">{isNew ? 'Nuevo Cliente' : 'Editar Cliente'}</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              saveClient();
            }}
          >
            <label className="block mb-2">
              Subdominio:
              <input
                type="text"
                name="subdomain"
                value={form.subdomain}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
                required
              />
            </label>

            <label className="block mb-2">
              Client ID:
              <input
                type="text"
                name="client_id"
                value={form.client_id}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
                required
              />
            </label>

            <label className="block mb-4">
              Secret Key:
              <input
                type="text"
                name="secret_key"
                value={form.secret_key}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
                required
              />
            </label>

            <label className="block mb-2">
              Sitio Wix:
              <select
                className="border rounded w-full px-2 py-1 mt-1"
                onChange={(e) => {
                  const selected = wixSites.find(site => site.id === e.target.value);
                  if (selected) {
                    setForm({
                      ...form,
                      wix_site_id: selected.id || '',
                      wix_site_name: selected.displayName || '',
                    });
                  }
                }}
                defaultValue={form.wix_site_id || ''} // Asegúrate de que el valor por defecto sea una cadena vacía si no hay sitio seleccionado

              >
                <option value="" disabled>Selecciona un sitio de Wix</option>
                {wixSites.map(site => (
                  <option key={site.id} value={site.id}>
                    {site.displayName} - {site.id}
                  </option>
                ))}
              </select>
            </label>
            <label className="block mb-4">
              Wix APP Instance ID:
              <input
                type="text"
                name="wix_app_instance_id"
                value={form.wix_app_instance_id || ''}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
              />
            </label>
            <label className="block mb-4">
              Fecha de Control:
              <input
                type="text"
                name="fecha_control"
                value={form.fecha_control || ''}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
              />
            </label>
            <label className="block mb-4">
              Bodega AG Factura:
              <input
                type="text"
                name="bodega_inventario"
                value={form.bodega_inventario || ''}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
                required
              />
            </label>
            <label className="block mb-4">
              Estado:
              <select
                name="estado"
                value={form.estado || 'A'}
                onChange={handleChange}
                className="border rounded w-full px-2 py-1 mt-1"
                required
              >
                <option value="A">Activo</option>
                <option value="I">Inactivo</option>
              </select>
            </label>

            <div className="flex gap-2">
              <button
                type="submit"
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 flex items-center gap-2"
              >
                <FaSave />
                Guardar
              </button>
              <button
                type="button"
                className="px-4 py-2 bg-gray-400 text-black rounded hover:bg-gray-500 flex items-center gap-2"
                onClick={cancelEdit}
              >
                <FaTimes />
                Cancelar
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
function uuidToAlphaOnly(uuid) {
  // Elimina guiones
  const hex = uuid.replace(/-/g, '');
  
  // Convierte a BigInt
  const bigIntValue = BigInt('0x' + hex);

  // Convierte a base26 (a–z)
  const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  let result = '';
  let current = bigIntValue;

  while (current > 0) {
    const remainder = current % 26n;
    result = alphabet[Number(remainder)] + result;
    current = current / 26n;
  }

  return "WIX-" + result;
}